import PropTypes from 'prop-types';

import './index.less';

function MenuSelectorGroup({ children, title, subTitle, ...props }) {
  return (
    <div className="menu-selector-group" data-testid={props['data-testid']}>
      {title && <div className="menu-selector-group__title">{title}</div>}
      {subTitle && <div className="menu-selector-group__subTitle">{subTitle}</div>}
      {children && <div className="menu-selector-group__menu-selector-container">{children}</div>}
    </div>
  );
}

MenuSelectorGroup.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  subTitle: PropTypes.node,
  'data-testid': PropTypes.string,
};

export default MenuSelectorGroup;
